import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import { Outlet, useLocation } from "react-router-dom";
import NotFound from "../../pages/NotFound/NotFound";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import { isEmpty } from "lodash";
import { T_ValidateSSOOldRes } from "../Feature_SSO/Sso_Types";
import { UseMfBaseDataLoader } from "./BaseDataInit/MF_Init_BaseData";
import { useEffect } from "react";
import { updateLoadingState } from "../Feature_Loading/Loading_Slice";

const MutualFundGuard = () => {
  const dispatch = useAppDispatch();
  const { state } = useLocation();
  const csAppSlice = useAppSelector((st) => st.CsAppSlice);
  const userDetails = csAppSlice.userDetails;
  const ssoSlice = useAppSelector((st) => st.SsoSlice.ssoData);
  let panNumber = state?.panNumber || userDetails?.pan || "";
  let dob = userDetails?.dob || "";
  if (isEmpty(panNumber) && csAppSlice.channel !== E_ChannelOptions.CSAPP) {
    panNumber =
      csAppSlice.userDetails?.customerAndLobDetails?.find((f) =>
        (ssoSlice as T_ValidateSSOOldRes)?.lobCode?.includes(f.LOB_CODE)
      )?.PAN || "";
  }
  const { isFetching, error } = UseMfBaseDataLoader(panNumber, dob,"primary");

  useEffect(() => {
    if (isFetching) {
      dispatch(updateLoadingState(true));
    } else {
      dispatch(updateLoadingState(false));
    }
  }, [isFetching]);

  return error ? (
    <NotFound moduleName="MF" pageName="MutualFundGuard" errorTitle="" errorMessage={error} />
  ) : isFetching || isEmpty(panNumber) ? (
    <></>
  ) : (
    <Outlet />
  );
};

export default MutualFundGuard;
